import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../context/SocketContext';
import { dicebear, photoUrl } from '../utils/api';

export default function IncomingCallOverlay() {
  const { incomingCall, acceptGlobalCall, rejectGlobalCall } = useSocket();
  const navigate = useNavigate();

  if (!incomingCall) return null;

  const avatar = photoUrl(incomingCall.callerPhoto) || dicebear(incomingCall.callerName);

  const handleAccept = () => {
    acceptGlobalCall();                        // stores pendingCall in context
    navigate(`/chat/${incomingCall.roomId}`);  // navigate to chat — PrivateChat auto-answers
  };

  const handleReject = () => rejectGlobalCall();

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      background: 'var(--overlay)', backdropFilter: 'blur(18px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        textAlign: 'center', padding: '40px 36px',
        background: 'var(--glass-bg)',
        backdropFilter: 'blur(32px)', WebkitBackdropFilter: 'blur(32px)',
        border: '1px solid rgba(110,200,138,0.3)',
        borderRadius: '24px', minWidth: '300px',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.18), 0 24px 64px rgba(0,0,0,0.7)',
        animation: 'callSlideIn 0.3s cubic-bezier(0.34,1.56,0.64,1)',
      }}>
        {/* Pulsing avatar */}
        <div style={{
          width: '96px', height: '96px', borderRadius: '50%',
          overflow: 'hidden', margin: '0 auto 20px',
          border: '3px solid rgba(110,200,138,0.7)',
          animation: 'ringPulse 1.2s ease-in-out infinite',
        }}>
          <img src={avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>

        <h3 style={{
          fontFamily: 'var(--font-display)', fontSize: '1.25rem',
          fontWeight: 700, marginBottom: '6px', color: 'var(--text)',
        }}>
          {incomingCall.callerName}
        </h3>
        <p style={{ color: 'var(--text3)', fontSize: '0.82rem', marginBottom: '32px' }}>
          Incoming {incomingCall.callType === 'video' ? '📹 video' : '📞 audio'} call…
        </p>

        <div style={{ display: 'flex', gap: '28px', justifyContent: 'center', alignItems: 'center' }}>
          {/* Decline */}
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={handleReject}
              style={{
                width: '60px', height: '60px', borderRadius: '50%',
                background: 'var(--color-decline)', border: 'none', cursor: 'pointer',
                fontSize: '1.5rem', display: 'flex', alignItems: 'center',
                justifyContent: 'center', margin: '0 auto',
                boxShadow: '0 4px 20px rgba(239,68,68,0.4)',
                transition: 'transform 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            >📵</button>
            <p style={{ color: 'var(--text3)', fontSize: '0.7rem', marginTop: '7px' }}>Decline</p>
          </div>

          {/* Accept */}
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={handleAccept}
              style={{
                width: '60px', height: '60px', borderRadius: '50%',
                background: 'var(--color-accept)', border: 'none', cursor: 'pointer',
                fontSize: '1.5rem', display: 'flex', alignItems: 'center',
                justifyContent: 'center', margin: '0 auto',
                boxShadow: '0 4px 20px rgba(34,197,94,0.4)',
                transition: 'transform 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              {incomingCall.callType === 'video' ? '📹' : '📞'}
            </button>
            <p style={{ color: 'var(--text3)', fontSize: '0.7rem', marginTop: '7px' }}>Accept</p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes callSlideIn {
          from { opacity: 0; transform: scale(0.88) translateY(16px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes ringPulse {
          0%,100% { box-shadow: 0 0 0 0 rgba(110,200,138,0.55); }
          50%      { box-shadow: 0 0 0 18px rgba(110,200,138,0); }
        }
      `}</style>
    </div>
  );
}
